export enum WorkPacketType {
  CHARGEBACKS = "chargebacks",
  SHORTAGES = "shortages",
  ACCRUALS = "accruals",
}
